import { useCoreTranslations } from '@solinkcorp/authentication';
import React from 'react';
import CenteredLoadingSpinner from './CenteredLoadingSpinner';

interface PageLoadingSpinnerProps {
  message?: string;
}

/** Spinner to use for `Loadable()` when loading a page. */
const PageLoadingSpinner: React.FC<PageLoadingSpinnerProps> = (props) => {
  const i18n = useCoreTranslations();
  return (
    <CenteredLoadingSpinner style={{ position: 'fixed' }} message={props.message || i18n.loading} />
  );
};

export default React.memo(PageLoadingSpinner);
